/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { catchError, Observable, of, tap } from 'rxjs';
import { IQualifier } from 'src/app/shared/interfaces/provider/provider.interfaces';
import { CommonGraphqlService } from 'src/app/shared/services/common.graphql.service';
import { SharedDataService } from 'src/app/shared/services/shared/shared-data.service';

@Component({
  selector: 'qualifiers',
  templateUrl: './qualifiers.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => {
        return QualifiersComponent;
      }),
      multi: true,
    },
  ],
})
export class QualifiersComponent implements ControlValueAccessor, OnInit {
  @Input() disabled = false;
  @Input() class = '';
  @Input() labelBaseClass = 'checkbox';
  @Input() inputClass = '';
  @Input() placeholder = 'Select Identifier';
  @Input() required = false;

  @Input() isFullInterface = false;

  qualifiers$: Observable<IQualifier[]>;

  value?: IQualifier | string = '';

  isLoading = true;

  private qualifiers: IQualifier[];

  onChange: (value?: IQualifier | string) => void;
  onTouched: () => void;

  constructor(
    private commonGraphqlService: CommonGraphqlService,
    private sharedDataService: SharedDataService,
  ) {}

  ngOnInit() {
    this.qualifiers$ = this.commonGraphqlService.getBillingTypes().pipe(
      tap((arr) => {
        this.qualifiers = arr;
        this.isLoading = false;
      }),
      catchError(() => {
        return of([]);
      }),
    );
  }

  writeValue(value: string) {
    this.value = value
      ? this.isFullInterface
        ? this.qualifiers.find((x) => {
            return x.code === value;
          })
        : value
      : '';

    this.onValueChanged();
  }

  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  registerOnTouched(fn: any) {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean) {
    this.disabled = isDisabled;
  }

  //#endregion

  onValueChanged() {
    this.onChange(
      this.isFullInterface ? this.value : (this.value as IQualifier).code,
    );
    if ((this.value as IQualifier).code == 'XX') {
      this.sharedDataService.maxLength = 10;
    } else if ((this.value as IQualifier).code == 'EI') {
      this.sharedDataService.maxLength = 9;
    } else {
      this.sharedDataService.maxLength = 25;
    }
  }
}
